'use strict';

const getQueryString = function (params) {
  var queryParts = Object.keys(params).map(function (key) {
    return key + '=' + String(params[key]);
  });

  return '?' + queryParts.join('&');
};


export default function f(config, deviceCapabilities) {
  'ngInject';

  var imgUrl = config.imgUrl;
  var imgQuality = config.imgQuality;
  var devicePixelRatio = (deviceCapabilities.pixelRatio >= 1.5) ? 1.5 : 1;

  return {
    getUrl: function getUrl(photo, size, crop) {
      var params = {
        w: size.w,
        h: size.h,
        dpr: size.dpr || devicePixelRatio,
        q: imgQuality
      };

      if (crop) {
        params.rect = crop;
      }

      return imgUrl + photo.path + getQueryString(params);
    },
    getCropCoords: function getCropCoords(crop) {
      var x1 = crop.x1;
      var y1 = crop.y1;
      var x2 = crop.x2;
      var y2 = crop.y2;

      return String(x1 + ',' + y1 + ',' + (Math.abs(x2 - x1)) + ',' + (Math.abs(y2 - y1)));
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/imgix_helpers.js